import React, { useCallback } from 'react';

import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';

import { PARENT_PRODUCTS } from '../common/constants';

import ConfluencePagePreviewPanel from './confluence-page-preview-panel';

export const useConfluencePagePreviewPanel = (
	parentProduct: (typeof PARENT_PRODUCTS)[keyof typeof PARENT_PRODUCTS],
) => {
	const { open, close } = usePreviewPanelsActions();

	const openConfluencePagePreviewPanel = useCallback(
		(title: string, url: string) => {
			open({
				panel: {
					id: `confluence-page-preview-panel-${title}`,
					type: 'confluence-page',
					content: () => (
						<ConfluencePagePreviewPanel
							props={{ title, url, parentProduct }}
							entryPoints={{}}
							extraProps={{}}
							queries={{}}
						/>
					),
				},
			});
		},
		[open, parentProduct],
	);

	const closeConfluencePagePreviewPanel = useCallback(() => {
		const onClose = () => {};
		close(onClose);
	}, [close]);

	return { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel };
};
